import React from "react";
import withStyles from "react-jss";
import PropTypes from "prop-types";

const logoStyle = theme => ({
    root: {
        marginBottom: "35px",
        "& img": {
            height: "45px",
            maxWidth: "100%",
        },
    },
    [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
        root: {
            marginBottom: "62px",
            marginTop: "4px",
            "& img": {
                height: "39px",
            },
        },
    },
});

const Logo = withStyles(logoStyle)(({ children, classes }) => {
    return <div className={classes.root}>{children}</div>;
});

Logo.propTypes = {
    children: PropTypes.node,
};

export default Logo;
